export default __webpack_public_path__ + "static/media/donations.917270c2.svg";